import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SponsorsComponent } from '../sponsors-component/sponsors-component';
import { InfoComponent } from '../info-component/info-component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { CommonModule, NgFor } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-open-squash-component',
  imports: [RouterModule, RouterOutlet, CommonModule, SponsorsComponent, SponsorsComponent],
  templateUrl: './open-squash-component.html',
  styleUrl: './open-squash-component.scss',
})
export class OpenSquashComponent implements OnInit, OnDestroy {

  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.setTournament('tu4I1g3CgO8WCvAiIcmA');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(tournament => {
      this.tournament = tournament;
      this.categories = tournament.categories.sort((a, b) => a.categoryOrder - b.categoryOrder);
    });
  }

  authAdmin() {
    this.dialog.open(AdminAuthComponent).afterClosed().subscribe(result => {
      if (result) {
        this.openSquashService.setAsAdmin(true);
      }
    });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }

}
